import type { CartMachineState} from '~/features/cart/state-machine/cartMachine';
import { POSITION_AVAILABILITY_OPTIONS_ACTOR_ID } from '~/features/cart/state-machine/cartMachine';
import type { CartEventTypes } from '~/features/cart/state-machine/events';
import { isDebugLogEnabled } from '~/tracking/logger';
import { getTransgourmetTraceIdClientSide } from '~/shell/cookies';
import { logToConsole } from '../../logging/consoleLogger';
import { formatLogTimestamp } from '../../../server/utils/logTimestamp.ts';

const CART_TRACES: string[] = [];
export function getCartTraces() {
  return CART_TRACES;
}

export const CART_MACHINE_LOGGER = {
  next: (state: CartMachineState) => {
    let oderTraceDetail: any = undefined;
    const currentOrder = state.context?.currentOrder;
    if (currentOrder) {
      oderTraceDetail = {
        orderId: currentOrder.id,
        desiredDeliveryDate: currentOrder?.desiredDeliveryDate
      };
    }

    const transgourmetTraceId = getTransgourmetTraceIdClientSide();
    if (transgourmetTraceId) {
      oderTraceDetail = oderTraceDetail || {};
      oderTraceDetail.traceId = transgourmetTraceId;
    }

    const timestamp = formatLogTimestamp();
    appendCartTrace(`CART STATE: ${printState(state.value)} [${timestamp}]`,'color: green; font-weight: bold;',oderTraceDetail);
    const positionAvailabilityWorkflow = state.children[POSITION_AVAILABILITY_OPTIONS_ACTOR_ID];
    if (positionAvailabilityWorkflow) {
      const snapshot: any = positionAvailabilityWorkflow.getSnapshot();
      appendCartTrace(
        `>> POSITION AVAILABILITY OPTIONS: ${printState(snapshot.value)}`,
        'color: teal; font-weight: bold;'
      );
    }
  },
  error: (error: unknown) => {
    appendCartTrace('CART ERROR!', 'color: red; font-weight: bold;', error);
  },
  complete: () => {}
};

export function logCartEvent(event: typeof CartEventTypes) {
  appendCartTrace(`CART EVENT: ${stringifyObject(event)}`, 'color: HotPink; font-weight: bold;');
}

export function clearCartTraces() {
  CART_TRACES.length = 0;
}

function appendCartTrace(message: string, fontSpec: string, ...optionalParams: any[]) {
  let params = optionalParams || [];
  params = params.filter(p => p !== undefined);
  if (isDebugLogEnabled()) {
    logToConsole({ fontSpec, loggerName: 'cart-machine', logLevel: 'INFO', message, args: params });
  }

  let trace = message;
  trace += params.length > 0 ? ` ${stringifyObject(params)}` : '';
  CART_TRACES.push(trace);
}

function printState(stateValue: CartMachineState['value'], path: string[] = []) {
  let result = '';
  if (typeof stateValue === 'string') {
    result = stateValue;
  } else {
    for (const key in stateValue) {
      if (typeof stateValue[key] === 'object' && stateValue[key] !== null) {
        result += printState(stateValue[key], [...path, key]);
      } else {
        result += [...path, key, stateValue[key]].join(' -> ');
      }
    }
  }
  return result;
}

function stringifyObject(obj) {
  // Einfache Umwandlung von Objekten in Strings für Traces.
  // `JSON.stringify` würde zu unnötigen Anführungszeichen und Escape-Zeichen führen.
  if (Array.isArray(obj)) {
    return `[${obj.map(stringifyObject).join(', ')}]`;
  } else if (typeof obj === 'object' && obj !== null) {
    return `{${Object.entries(obj)
      .map(([k, v]) => `${k}: ${stringifyObject(v)}`)
      .join(', ')}}`;
  } else if (typeof obj === 'string') {
    return obj; // No quotes, or add single quotes if needed
  } else {
    return String(obj);
  }
}
